import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Observable } from 'rxjs';

import { MatIcon } from '@angular/material/icon';
@Component({
  selector: 'app-ownership-confirm-dialog',
  imports: [
    MatDialogModule,
    MatDialogActions,
    MatProgressSpinnerModule,
    CommonModule,
    MatDialogContent,
    MatButtonModule,
    MatDialogContent,
    MatIcon,
  ],
  templateUrl: './ownership-confirm-dialog.html',
  styleUrl: './ownership-confirm-dialog.css',
})
export class OwnershipConfirmDialog {
  loading = false;
  success = false;
  errorMessage: string | null = null;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      message: string;
      confirmAction: () => Observable<any>;
      confirmText?: string;
      cancelText?: string;
    },
    private readonly dialogRef: MatDialogRef<OwnershipConfirmDialog>
  ) {}
  submitting = false;
  dialogState: 'confirm' | 'error' = 'confirm';

  onConfirm(): void {
    this.submitting = true;
    this.errorMessage = null;

    this.data.confirmAction().subscribe({
      complete: () => {
        this.dialogRef.close(true);
      },

      error: (err) => {
        this.dialogState = 'error';

        this.errorMessage =
          err?.message ||
          (typeof err === 'string' ? err : null) ||
          'A system error occured. Please try again later.';

        this.submitting = false;
      },
    });
  }

  onOk(): void {
    this.dialogRef.close(false);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
  closeDialog(): void {
    this.dialogRef.close();
  }
}
